import React from 'react';

import Button from 'components/Button';

import './styles.css';

const Buttons = ({closeModal, onSubmit, active, submitting, label}) => (
  <div className="Buttons colab-row-space-between">
    <Button white onClick={closeModal}>
      Cancel
    </Button>
    <Button
      onClick={onSubmit}
      blue={active}
      isLoading={submitting}
      disabled={!active}>
      {label}
    </Button>
  </div>
);

export default Buttons;
